export {
  getSysNoticeUnReadNum,
  getSysNoticeList,
  updateSysNoticeRead,
  updateSysNoticeReadAll,
  deleteSysNoticeRead
} from './api'
